// extracted by mini-css-extract-plugin
export default {"home_header":"Header_home_header__WJjvu","home_img":"Header_home_img__MkAI9","items":"Header_items__jap2q","double":"Header_double__i73Pa"};